// extracted by mini-css-extract-plugin
module.exports = {"imageUploadBox":"UploadFile_imageUploadBox__1h1y9","imageUploadBoxContent":"UploadFile_imageUploadBoxContent__3ZpCP","unSelectimageBtn":"UploadFile_unSelectimageBtn__3bFQX"};